import { Component, OnInit, Input, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FilesService } from 'src/app/services/shared/files/files.service';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss'],
  providers: [FilesService]
})
export class FileUploadComponent implements OnInit {
  public active;
  public file;
  multiple;
  result = [];
  file_types;
  files = [];
  input = [];
  id;
  constructor(
    public dialogRef: MatDialogRef<FileUploadComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private file_service: FilesService
  ) {
    if (data) {
      this.multiple = data.multiple;
    }
    if (!this.multiple) {
      if (data && data.result) {
        this.result = [data.result];
      }
      else {
        this.result = [];
      }
    }
    else {
      if (data && data.result && data.result.length) {
        this.result = data.result || [];
      }
      else {
        this.result = [];
      }
    }
    this.file_types = data.file_types;

    this.input = JSON.parse(JSON.stringify(this.result || []));
  }

  ngOnInit() {
    this.id = Math.floor((Math.random() * 1000) + 1);

    this.files = [];
    let drop_zone = document.getElementById('drop-zone');

    ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
      drop_zone.addEventListener(eventName, (e) => {
        e.preventDefault()
        e.stopPropagation()
      }, false)
    })
    drop_zone.addEventListener('drop', this.fileInputDropped.bind(this), false);
  }

  fileInputDropped(ev) {

    this.fileInputChanged(ev.dataTransfer.files);
  }

  fileInputChanged(files) {

    this.file_service.convertFilesToBase64(files).subscribe((res: Array<any>) => {
      if (res && res.length) {
        if (!this.multiple) {
          this.result = JSON.parse(JSON.stringify(res));
        }
        else {
          this.result = [...this.result, ...res];
        }
      }
      else {
        this.result = [];
      }
      document.getElementById("input-file" + this.id)['value'] = null;
    })
  }

  removeFile(file) {
    if (file && file.attachment_id) {
      file.status = 2;
    }
    else {
      let index = this.result.indexOf(file);
      if (index > -1) {
        this.result.splice(index, 1);
      }
    }
  }

  cancel() {
    this.dialogRef.close(this.input);
  }
}
